<template>
  <div class="container">
    <v-card>
      <v-card-title>Recepción de bins</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" xs="12" md="4" lg="4" xl="4">
            <v-autocomplete
              v-model="reception.provider"
              :items="providers"
              :loading="isLoading"
              :search-input.sync="providerSearch"
              color="white"
              hide-no-data
              hide-selected
              item-text="name"
              item-value="id"
              label="Proveedor"
              placeholder="Escriba parte del nombre"
              prepend-icon="mdi-database-search"
              return-object
              persistent-hint
              clearable
            ></v-autocomplete>
            <v-autocomplete
              v-model="reception.facility"
              :items="facilities"
              :loading="isLoading"
              :search-input.sync="facilitySearch"
              @change="loadWaybills"
              color="white"
              hide-no-data
              hide-selected
              item-text="name"
              item-value="code"
              label="Lista de plantas de origen"
              placeholder="Escriba parte del nombre"
              prepend-icon="mdi-database-search"
              return-object
              persistent-hint
            ></v-autocomplete>
            <v-autocomplete
              v-model="reception.patent"
              :items="patents"
              :loading="isLoading"
              :search-input.sync="patentSearch"
              color="white"
              hide-no-data
              hide-selected
              item-text="IDENTIFICADOR"
              item-value="IDENTIFICADOR"
              label="Patentes"
              placeholder="Seleccione camión"
              prepend-icon="mdi-database-search"
              return-object
              @change="loadPesaje"
            ></v-autocomplete>
            <v-btn text>Fecha de Recepción</v-btn>
            <date-picker placeholder="Fecha" class="dtpicker" v-model="reception_date" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
            <v-select
              v-model="reception.shift"
              :items="shifts"
              item-text="name"
              item-value="id"
              label="Elija Turno"
              color="blue darken-3"
              persistent-hint
              return-object>
            </v-select>
            <v-autocomplete
              v-if="waybills.length > 0"
              v-model="reception.waybill"
              :items="waybills"
              :loading="isLoading"
              :search-input.sync="waybillSearch"
              @change="showWaybill"
              color="white"
              hide-no-data
              hide-selected
              item-text="ticket.CODIGO_GUIA"
              item-value="ticket.CODIGO_GUIA"
              label="Guia de Despacho"
              placeholder="Seleccione Guía"
              prepend-icon="mdi-database-search"
              return-object
            ></v-autocomplete>
            <v-text-field
              v-if="waybills.length == 0"
              prepend-icon="mdi-file-document"
              label="Guia de Despacho"
              placeholder="Guia de Despacho"
              v-model="reception.waybill"
              @change="showWaybill"
            ></v-text-field>
            <v-btn icon color="red" :href="waybillPath" v-if="reception.waybill.URL_GUIA"  target="_blank">
              <v-icon>mdi-file-pdf</v-icon>
            </v-btn>
            <v-btn
              color = "primary"
              @click="saveReception"
            >Grabar</v-btn>
            <v-btn
              @click="cleanForm"
            >Limpiar</v-btn>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
            <v-tabs
              v-model="tab"
              fixed-tabs
              background-color="indigo"
              dark
            >
              <v-tab>
                <v-badge
                  color="green"
                  :content="plpBins"
                >
                  Bins PLP
                </v-badge>
              </v-tab>
              <v-tab>
                <v-badge
                  color="green"
                  :content="otherBins"
                >
                  Otros Bins
                </v-badge>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-row>
                  <v-col xs="12" sm="12" md="6" lg="2" xl="2">
                    <v-select
                      v-model="binColor"
                      :items="colors"
                      @change="loadBins"
                      item-text="name"
                      item-value="id"
                      label="Color"
                      color="blue darken-3"
                      persistent-hint
                      return-object>
                    </v-select>
                  </v-col>
                  <v-col xs="12" sm="12" md="6" lg="2" xl="2">
                    <v-select
                      v-model="binSize"
                      :items="sizes"
                      @change="loadBins"
                      item-text="name"
                      item-value="id"
                      label="Tamaño"
                      color="blue darken-3"
                      persistent-hint
                      return-object>
                    </v-select>
                  </v-col>
                  <v-col xs="12" sm="12" md="6" lg="3" xl="3">
                    <v-autocomplete
                      v-model="bin"
                      :items="bins"
                      :loading="isLoading"
                      :search-input.sync="binSearch"
                      color="white"
                      hide-no-data
                      hide-selected
                      item-text="number"
                      item-value="id"
                      label="Número de BIN"
                      placeholder="Escriba parte del código"
                      prepend-icon="mdi-database-search"
                      return-object
                    ></v-autocomplete>
                  </v-col>
                  <v-col xs="12" sm="12" md="6" lg="3" xl="3">
                    <v-select
                      v-model="state"
                      :items="states"
                      item-text="name"
                      item-value="id"
                      label="Estado del bin"
                      color="blue darken-3"
                      persistent-hint
                      return-object>
                    </v-select>
                  </v-col>
                  <v-col xs="12" sm="12" md="6" lg="2" xl="2">
                    <v-btn @click="addBin"><v-icon>mdi-plus</v-icon></v-btn>
                  </v-col>
                </v-row>
                <v-data-table 
                  :headers="binsListHeaders"
                  :items="binsListBody"
                  class="elevation-1"
                  dense
                  no-data-text="No hay bins"
                >
                  <template v-slot:[`item.actions`]="{item}">
                    <v-icon
                      medium
                      @click="deleteBin(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item>
                <v-row>
                  <v-col xs="6" sm="4" md="3" lg="3" xl="3">
                    <v-select
                      v-model="otherOwner"
                      :items="otherOwners"
                      item-text="name"
                      item-value="id"
                      label="Elija Propietario"
                      color="blue darken-3"
                      persistent-hint
                      return-object>
                    </v-select>
                  </v-col>
                  <v-col xs="6" sm="4" md="3" lg="3" xl="3">
                    <v-select
                      v-model="color"
                      :items="colors"
                      item-text="name"
                      item-value="id"
                      label="Elija Color"
                      color="blue darken-3"
                      persistent-hint
                      return-object>
                    </v-select>
                  </v-col>
                  <v-col xs="6" sm="4" md="2" lg="2" xl="2">
                    <v-select
                      v-model="size"
                      :items="sizes"
                      item-text="name"
                      item-value="id"
                      label="Elija Tamaño"
                      color="blue darken-3"
                      persistent-hint
                      return-object>
                    </v-select>
                  </v-col>
                  <v-col xs="6" sm="4" md="2" lg="2" xl="2">
                    <v-text-field
                      placeholder="Cantidad"
                      v-model="quantity"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col xs="6" sm="4" md="2" lg="2" xl="2">
                    <v-btn @click="addOtherBin" dense><v-icon>mdi-plus</v-icon></v-btn>
                  </v-col>
                </v-row>
                <v-data-table 
                  :headers="othersListHeaders"
                  :items="othersListBody"
                  class="elevation-1"
                  dense
                  no-data-text="No hay bins"
                >
                  <template v-slot:[`item.code`]="{item}">
                    <v-text-field
                      prepend-icon="mdi-barcode"
                      placeholder="Codigo"
                      v-model="item.code"
                      @change= "loadBin(item)"
                    >
                    </v-text-field>
                  </template>
                  <template v-slot:[`item.actions`]="{item}">
                    <v-icon
                      medium
                      @click="deleteOtherBin(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-data-table 
      :headers="receptionsListHeaders"
      :items="receptionsListBody"
      class="elevation-1"
      no-data-text="No hay recepciones"
    >
      <template v-slot:[`item.actions`]="{item}">
        <v-icon
          medium
          class="mr-2"
          @click="editReception(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          medium
          @click="deleteReception(item)"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <!-- Modal Success -->
    <v-dialog
      v-model="dialog"
      transition="fab-transition"
      width="600px"
    >
      <v-card>
        <v-card-title class="blue darken-2">
          Resultado
        </v-card-title>
        <v-container>
          <v-row class="mx-2">
            <v-alert type="error" v-if="success == false">
              {{ validation_message }}
            </v-alert>
            <v-alert type="success" v-if="success == true">
              {{ validation_message }}
            </v-alert>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-btn
            @click="dialog = false"
          >Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Modal -->
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'
  //datepicker vue2
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import 'vue2-datepicker/locale/es';

  export default {
    props: {
      //source: String,
    },
    data: () => ({
      dialog: false,
      errors: [],
      validation_message: '',
      success: null,
      tab: null,
      code: 0,
      facilities: [],
      shifts: [],
      bin: null,
      bins: [],
      company: null,
      companies: [],
      otherOwner: null,
      otherOwners: [],
      providers: [],
      color: null,
      colors: [],
      size: null,
      binSize: 1,
      binColor: 1,
      sizes: [],
      state: null,
      states: [],
      quantity: '',
      waybills: [],
      waybillPath: '',
      binSearch: null,
      facilitySearch: null,
      providerSearch: null,
      waybillSearch: null,
      patents: [],
      patentSearch: null,
      isLoading: false,
      reception_date: new Date().toISOString().substr(0, 10),
      receptionIndex: -1,
      reception: {
        id: 0,
        facility: {
          id: 0,
          code: ''
        },
        provider: {
          id: 0,
          name: ''
        },
        shift: {
          id: 0,
          name: ''
        },
        waybill: '',
        patent: '',
        reception_date: new Date().toISOString().substr(0, 10),
      },
      receptionsListHeaders: [
        {
          text: 'Fecha',
          align: 'center',
          sortable: true,
          value: 'reception_date',
        },
        {
          text: 'Turno',
          align: 'center',
          sortable: true,
          value: 'shift.name',
        },
        {
          text: 'Planta Origen',
          align: 'center',
          sortable: true,
          value: 'facility.name',
        },
        {
          text: 'Guia Despacho',
          align: 'center',
          sortable: true,
          value: 'waybill',
        },
        {
          text: 'Patente',
          align: 'center',
          sortable: true,
          value: 'patent',
        },
        {
          text: 'Bins',
          align: 'center',
          sortable: true,
          value: 'bins',
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ],
      receptionsListBody: [],
      binsListHeaders: [
        {
          text: 'Codigo',
          align: 'center',
          sortable: true,
          value: 'bin.code',
        },
        {
          text: 'Estado',
          align: 'center',
          sortable: true,
          value: 'state.name',
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ],
      binsListBody: [],
      othersListHeaders: [
        {
          text: '#',
          align: 'center',
          sortable: true,
          value: 'quantity',
        },
        {
          text: 'Propietario',
          align: 'center',
          sortable: true,
          value: 'company.name',
        },
        {
          text: 'Color',
          align: 'center',
          sortable: true,
          value: 'color.name',
        },
        {
          text: 'Tamaño',
          align: 'center',
          sortable: true,
          value: 'size.name',
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ],
      othersListBody: [],
    }),
    mounted() {
      this.loadFacilities();
      this.loadColors();
      this.loadSizes();
      this.loadStates();
      this.loadCompanies();
      this.loadOtherOwners();
      this.loadShifts();
      this.loadReceptions();
      this.loadWaybills();
      this.loadPatents();
    },
    methods:{
      async loadCompanies(){
        let url = `${this.base_url}companies`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.companies = response.data.data;
            this.providers = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadOtherOwners(){
        let url = `${this.base_url}other_owners`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.otherOwners = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadFacilities(){
        let url = `${this.base_url}facilities`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.facilities = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadColors(){
        let url = `${this.base_url}colors`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.colors = response.data.data;
            this.binColor = this.colors[0];
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadSizes(){
        let url = `${this.base_url}sizes`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.sizes = response.data.data;
            this.binSize = this.sizes[0];
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadStates(){
        let url = `${this.base_url}states`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.states = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadShifts(){
        let url = `${this.base_url}shifts`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.shifts = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadBins(){
        let url = `${this.base_url}bins/to_receive/bysize/${this.binSize.id}/${this.binColor.id}`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.bins = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadWaybills(){
        if(this.reception.facility.code == '') return;
        let url = `${this.base_url}waybills/bysourcefacility/${this.reception.facility.code}`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.waybills = response.data.data;
            //this.reception.waybill = {};
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadPatents(){
        let url = `${this.base_url}tickets/patents`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.patents = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadBin(item){
        let url = `${this.base_url}bins/${item.code}`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.bin = response.data.data;
            let index = this.binsListBody.indexOf(item);
            this.binsListBody.splice(index, 1, this.bin);
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadPesaje(){
        let url = `${this.base_url}receptions/pesaje/${this.reception.patent}`;
        await this.axios.get(url, this.headers).then((response)=>{
            console.log(response.data.data);
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadReceptions(){
        let url = `${this.base_url}receptions`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.receptionsListBody = response.data.data;
            this.loadBins();
        }).catch((error)=>{
            console.log(error);
        });
      },
      async saveReception(){
        // validation
        this.success = null;
        this.validation_message = "";
        this.errors = [];
        if(!this.reception.provider.id){
          this.errors.push("Debe seleccionar proveedor");
        }
        if(!this.reception.facility.id){
          this.errors.push("Debe seleccionar planta de origen");
        }
        if(!this.reception.patent){
          this.errors.push("Debe seleccionar una patente");
        }
        if(!this.reception.shift.id){
          this.errors.push("Debe seleccionar un turno");
        }
        if(!this.reception.waybill){
          this.errors.push("Debe indicar guía de despacho");
        }
        if(this.binsListBody.length == 0 && this.othersListBody.length == 0){
          this.errors.push("Debe ingresar bins");
        }
        //console.log(this.reception.waybill);
        //this.errors.push("Quitar error");
        let waybill = this.reception.waybill;
        if(this.reception.waybill.ticket != undefined){
          waybill = this.reception.waybill.ticket.CODIGO_GUIA;
        }
        if(this.errors.length > 0){
          this.success = false;
          this.validation_message = this.errors.join();
          this.dialog = true;
          return;
        }
        let url = `${this.base_url}receptions`;
        let sendData = {
          'reception':{
            'main': {
              'provider_id': this.reception.provider.id,
              'facility_id': this.reception.facility.id,
              'reception_date': this.reception.reception_date,
              'shifts_id': this.reception.shift.id,
              'patent': this.reception.patent,
              'waybill': waybill,
            },
            'plp_details': [],
            'other_details': []
          }
        };
        this.binsListBody.forEach(item => {
          let data = {
            'receptions_id': 0,
            'bins_id': item.bin.id,
            'state_id': item.state.id,
            'photo': ''
          }
          sendData.reception.plp_details.push(data);
        });
        this.othersListBody.forEach(bin => {
          let data = {
            'receptions_id': 0,
            'companies_id': bin.company.id,
            'colors_id': bin.color.id,
            'sizes_id': bin.size.id,
            'quantity': bin.quantity
          }
          sendData.reception.other_details.push(data);
        });

        if(this.reception.id > 0){
          url = url + "/" + this.reception.id;
          await this.axios.put(url, JSON.stringify(sendData), this.headers).then((response)=>{
            /*
            let index = this.receptionsListBody.map(reception => {
              return reception.id;
            }).indexOf(this.reception.id);
            this.binsListBody.splice(index, 1, response.data.data);
            */
            console.log(response.data.data);
            this.validation_message = "Grabado exitosamente!";
            this.success = true;
            this.dialog = true;
            this.cleanForm();
          }).catch((error)=>{
            this.success = false;
            this.errors = error.response.data.data;
            this.validation_message = this.errors.join();
            this.dialog = true;
          });
        }else{
          await this.axios.post(url, JSON.stringify(sendData), this.headers).then((response)=>{
            //this.receptionsListBody.push(response.data.data);
            console.log(response.data.data);
            this.validation_message = "Grabado exitosamente!";
            this.success = true;
            this.dialog = true;
            this.cleanForm();
            this.loadBins();
          }).catch((error)=>{
            this.success = false;
            this.errors = error.response.data.data;
            this.validation_message = this.errors.join();
            this.dialog = true;
          });
        }
        this.loadReceptions();
      },
      cleanForm(){
        this.binsListBody = [];
        this.othersListBody = [];
        let waybill = "";
        if(this.waybills.length > 0){
          waybill = {};
        }
        this.reception = {
          id: 0,
          facility: {
            id: 0,
            code: ''
          },
          shift: {
            id: 0,
            name: ''
          },
          waybill: waybill,
          patent: '',
          reception_date: new Date().toISOString().substr(0, 10),
        }
      },
      addBin(){
        let bin = this.binsListBody.filter(item => {
          return item.bin.number == this.bin.number && item.bin.sizes_id == this.bin.sizes_id && item.bin.colors_id == this.bin.colors_id;
        });
        if(bin.length == 0){
          this.binsListBody.push({bin: this.bin, state: this.state});
        }
      },
      copyBin(){

      },
      addOtherBin(){
        this.othersListBody.push({company: this.otherOwner, color: this.color, size: this.size, quantity: this.quantity});
      },
      editReception(item) {
        console.log(item);
        this.receptionIndex = this.receptionsListBody.indexOf(item);
        this.reception = Object.assign({}, item);
        this.binsListBody = this.reception.plp_bins;
        this.othersListBody = this.reception.other_bins;
        this.loadWaybills();
      },
      deleteReception(item) {
        this.$confirm('Desea borrar esta recepción?').then(res => {
          if(res){
            const index = this.receptionsListBody.indexOf(item);
            this.receptionsListBody.splice(index, 1);
          }
        });
      },
      deleteBin(item) {
        this.$confirm('Desea quitar este bin?').then(res => {
          if(res){
            const index = this.binsListBody.indexOf(item);
            this.binsListBody.splice(index, 1);
          }
        });
      },
      deleteOtherBin(item) {
        this.$confirm('Desea quitar este bin?').then(res => {
          if(res){
            const index = this.othersListBody.indexOf(item);
            this.othersListBody.splice(index, 1);
          }
        });
      },
      showWaybill(){
        this.waybillPath = `https://190.13.184.67/plp-ori/archivos/guias de despacho/${this.reception.waybill.URL_GUIA}.pdf`;
      },
      ...mapMutations(['actualizarBaseUrl']),
    },
    computed:{
      plpBins: function(){
        return this.binsListBody.length;
      },
      otherBins: function(){
        let quantity = 0;
        this.othersListBody.forEach(bin => {
          quantity += parseInt(bin.quantity);
        });
        return quantity;
      },
      ...mapState(['authenticated', 'loading', 'base_url', 'headers'])
    },
    components:{
      DatePicker
    }
  }
</script>